import Preact from 'preact';

var FormStructure = {
    fields: {
        headerLabel: {
            validations: []
        },
        FirstName: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        LastName: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        ClientName: {
            validations: []
        },
        Email: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' },
                { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
            ]
        },
        AccountExtra1: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' },
                { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
            ]
        },
        AddressLine1: {
            validations: []
        },
        AccountExtra2: {
            validations: []
        },
        City: {
            validations: []
        },
        State: {
            validations: []
        },
        Postal: {
            validations: [
                { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
            ]
        },
        TelNumber: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' },
                { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
            ]
        },
        AccountExtra3: {
            validations: []
        },
        EventDate: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' },
                { type: 'dateinfuture', message: 'Event date must be in the future.' }
            ]
        },
        Category: {
            validations: []
        },
        PartyName: {
            validations: []
        },
        PlannedGuestCount: {
            validations: [
                { type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.' }
            ]
        },
        EventExtra2: {
            validations: []
        },
        EventExtra3: {
            validations: []
        },
        EventExtra4: {
            validations: []
        },
        EventExtra5: {
            validations: [
                { type: 'dateinfuture', message: 'Event date must be in the future.' }
            ]
        },
        EventExtra6: {
            validations: [
                { type: 'dateinfuture', message: 'Event date must be in the future.' }
            ]
        },
        EventExtra7: {
            validations: [
                { type: 'dateinfuture', message: 'Event date must be in the future.' }
            ]
        },
        EventExtra8: {
            validations: [
                { type: 'dateinfuture', message: 'Event date must be in the future.' }
            ]
        },
        EventExtra9: {
            validations: []
        },
        Description: {
            validations: []
        },
        Notes: {
            validations: []
        }
    },
    layout: {
        rows: [
            {
                fields: [
                    {
                    type: 'label',
                    size: 'Medium',
                    label: 'Contact Information',
                    mapping: 'headerLabel',
                    customClasses: ['header']
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'First Name',
                    mapping: 'FirstName'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Last Name',
                    mapping: 'LastName'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Company / Organization',
                    mapping: 'ClientName'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Email',
                    mapping: 'Email'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Confirm Email',
                    mapping: 'AccountExtra1'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Address Line 1',
                    mapping: 'AddressLine1'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Address Line 2',
                    mapping: 'AccountExtra2'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'City',
                    mapping: 'City'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'State',
                    options: [
                        { label: 'AL', value: 'AL' },
                        { label: 'AK', value: 'AK' },
                        { label: 'AZ', value: 'AZ' },
                        { label: 'AR', value: 'AR' },
                        { label: 'CA', value: 'CA' },
                        { label: 'CO', value: 'CO' },
                        { label: 'CT', value: 'CT' },
                        { label: 'DE', value: 'DE' },
                        { label: 'DC', value: 'DC' },
                        { label: 'FL', value: 'FL' },
                        { label: 'GA', value: 'GA' },
                        { label: 'HI', value: 'HI' },
                        { label: 'ID', value: 'ID' },
                        { label: 'IL', value: 'IL' },
                        { label: 'IN', value: 'IN' },
                        { label: 'IA', value: 'IA' },
                        { label: 'KS', value: 'KS' },
                        { label: 'KY', value: 'KY' },
                        { label: 'LA', value: 'LA' },
                        { label: 'ME', value: 'ME' },
                        { label: 'MD', value: 'MD' },
                        { label: 'MA', value: 'MA' },
                        { label: 'MI', value: 'MI' },
                        { label: 'MN', value: 'MN' },
                        { label: 'MS', value: 'MS' },
                        { label: 'MO', value: 'MO' },
                        { label: 'MT', value: 'MT' },
                        { label: 'NE', value: 'NE' },
                        { label: 'NV', value: 'NV' },
                        { label: 'NH', value: 'NH' },
                        { label: 'NJ', value: 'NJ' },
                        { label: 'NM', value: 'NM' },
                        { label: 'NY', value: 'NY' },
                        { label: 'NC', value: 'NC' },
                        { label: 'ND', value: 'ND' },
                        { label: 'OH', value: 'OH' },
                        { label: 'OK', value: 'OK' },
                        { label: 'OR', value: 'OR' },
                        { label: 'PA', value: 'PA' },
                        { label: 'RI', value: 'RI' },
                        { label: 'SC', value: 'SC' },
                        { label: 'SD', value: 'SD' },
                        { label: 'TN', value: 'TN' },
                        { label: 'TX', value: 'TX' },
                        { label: 'UT', value: 'UT' },
                        { label: 'VT', value: 'VT' },
                        { label: 'VA', value: 'VA' },
                        { label: 'WA', value: 'WA' },
                        { label: 'WV', value: 'WV' },
                        { label: 'WI', value: 'WI' },
                        { label: 'WY', value: 'WY' }
                    ],
                    mapping: 'State'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Zip Code',
                    mapping: 'Postal'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Phone Number',
                    mapping: 'TelNumber'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'radio-buttons',
                    size: 'Medium',
                    label: 'Contact Me By',
                    options: [
                        { label: 'Email', value: 'Email' },
                        { label: 'Phone', value: 'Phone' }
                    ],
                    mapping: 'AccountExtra3'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'label',
                    size: 'Medium',
                    label: 'Your Event Details',
                    mapping: 'headerLabel',
                    customClasses: ['header']
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'date-picker-nofill',
                    size: 'Medium',
                    label: 'Event Date Requested',
                    mapping: 'EventDate'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'radio-buttons',
                    size: 'Medium',
                    label: 'Category',
                    options: [
                        { label: 'Business Meeting', value: 'Business Meeting' },
                        { label: 'Wedding Reception', value: 'Wedding Reception' },
                        { label: 'Social Event', value: 'Social Event' },
                        { label: 'Golf Event', value: 'Golf Event' },
                        { label: 'Other', value: 'Other' },
                    ],
                    mapping: 'Category',
                    customClasses: ['radio']
                }
            ]
          },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Group Name',
                    mapping: 'PartyName'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Number of Attendees',
                    mapping: 'PlannedGuestCount'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Food & Beverage Requirements',
                    mapping: 'EventExtra2'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'AV Requirements',
                    mapping: 'EventExtra3'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Electrical Requirements',
                    mapping: 'EventExtra4'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'label',
                    size: 'Medium',
                    label: 'Guestroom Block',
                    mapping: 'headerLabel',
                    customClasses: ['header']
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'date-picker-nofill',
                    size: 'Medium',
                    label: 'Arrival Date',
                    mapping: 'EventExtra5'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'date-picker-nofill',
                    size: 'Medium',
                    label: 'Departure Date',
                    mapping: 'EventExtra6'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'date-picker-nofill',
                    size: 'Medium',
                    label: 'Alternate Arrival Date',
                    mapping: 'EventExtra7'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'date-picker-nofill',
                    size: 'Medium',
                    label: 'Alternate Departure Date',
                    mapping: 'EventExtra8'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Number of Guestrooms',
                    mapping: 'EventExtra9'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'label',
                    size: 'Medium',
                    label: 'Comments',
                    mapping: 'headerLabel',
                    customClasses: ['header']
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text-area',
                    size: 'Medium',
                    label: 'Please provide any additional Event or Guestroom comments',
                    mapping: 'Description'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text-area',
                    size: 'Medium',
                    label: 'Please provide any special requirements for this group',
                    mapping: 'Notes'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'submit',
                    size: 'XLarge',
                    label: 'Submit'
                }
            ]
            }
        ]
    },
    info: {
        title: 'Coushatta Casino Resort Contact Form',
        formId: '732',
        clientKey: '975F1DE1-54D1-414B-9DDF-1CBE92509C6F',
        appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
        redirectUrl: 'https://www.coushattacasinoresort.com/meetings/confirmation/',
        submissionText: 'Thank you! A Coushatta associate will reach out to you shortly.',
        apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
    }
};


export default FormStructure;


// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/coushatta/form_structure.js